
export const ShortMonthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
export const ShortDayNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

export function getTimeInHours(d: Date) { return d.getHours() + d.getMinutes() / 60 }
export function getShortMonthAndDay(d: Date) { return (ShortDayNames[d.getDay()] + " " + ShortMonthNames[d.getMonth()]) + " " + d.getDate(); }